import React, {  useEffect, useState } from 'react'

const MwModal = ({children,onShow,setOnShow}) => {
    const [isHidden,setIsHidden] = useState(true);

    const onHide = () => {
        setIsHidden(true);
        setOnShow(false);
    }
    
    useEffect(()=>{
        if(onShow && isHidden){
            setIsHidden(false);
        }
    },[onShow,isHidden]);
    
    const ChildrenComponent = (props) => {
        return React.cloneElement(children, props);
    }
    return (
        <div className={`finance-modal-overlay flex flex-col items-center justify-center h-screen w-full fixed bottom-0 top-0 left-0 right-0 z-50 ${ !isHidden ? 'block' : 'hidden'  } `} >
            <div className='finance-modal-panel flex flex-col items-between justify-between w-11/12 md:w-4/6 rounded-lg overflow-y-auto relative'>
                <div className='h-full bg-white text-[#261759]' >
                    <ChildrenComponent onHide={onHide} /> 
                </div>
            </div>
        </div>
    )
}

export default MwModal
